import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { OrderPriceSummary, OrderPriceSummaryItem } from '@models/shopping-cart.model';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslationPipe } from '@pipes/translation/translation.pipe';

@Component({
  selector: 'ts-bulk-order-details',
  templateUrl: './bulk-order-details.component.html',
  imports: [CommonModule, TranslationPipe, NgbTooltip]
})
export class BulkOrderDetailsComponent {
  @Input() price_summary: OrderPriceSummary;

  get is_employee_payable(): boolean | undefined {
    return Boolean(
      this.price_summary?.one_time_costs?.find(
        (cost: OrderPriceSummaryItem) =>
          cost.employee_cost_to_currency && (cost.type == 'ACCESSORY' || 'DEVICE')
      )
    );
  }

  get bulk_accessories_length(): boolean {
    if (
      this.price_summary?.bulk_order_additional_info?.bulk_accessories &&
      this.price_summary.bulk_order_additional_info.bulk_accessories.length > 0
    )
      return true;
    else return false;
  }

  get bulk_features_length(): boolean {
    if (
      this.price_summary?.bulk_order_additional_info?.bulk_features &&
      this.price_summary.bulk_order_additional_info.bulk_features.length > 0
    )
      return true;
    else return false;
  }

  get has_employee_one_time_costs(): boolean {
    return this.price_summary?.bulk_order_additional_info?.cost_per_bundle?.one_time_device_cost ||
      this.price_summary?.bulk_order_additional_info?.cost_per_bundle?.add_ons_cost
      ? true
      : false;
  }

  get has_employee_recurring_costs(): boolean {
    return this.price_summary?.bulk_order_additional_info?.cost_per_bundle?.recurring_device_cost ||
      this.price_summary?.bulk_order_additional_info?.cost_per_bundle?.plans_cost ||
      this.price_summary?.bulk_order_additional_info?.cost_per_bundle?.features_cost
      ? true
      : false;
  }
}
